import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import * as Constants from '../../../../SharedModules/AppConstants';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

// for loading spinner
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  payload: value,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setPaginationIndex = (value) => ({
  type: ActionTypes.SET_PAGINATION_INDEX_NDC_DETAILS,
  payload: value,
});

export const dispatchSelectType = (data) => ({
  type: ActionTypes.NDC_SELECT_TYPE,
  payload: data,
});

//Action to clear the store once report tab is closed
export const refreshNDCDetails = () => ({
  type: ActionTypes.REFRESH_NDC_DETAILS,
  payload: {},
});
export const refreshNDCDetailsDisplay = () => ({
  type: ActionTypes.REFRESH_NDC_DETAILS_DISPLAY,
  payload: {},
});
//  error msg dispatch function
export const dispatchErrorMsgNDCDetails = (data) => ({
  type: ActionTypes.GET_ERROR_MSG_NDC_DETAILS,
  payload: data,
});

//Action to set the store on search click of request screen
export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT_NDC_DETAILS,
  payload: data,
});

//For Quarter validation
export const handleErrorMesGenerateInvInRedux = (data) => ({
  type: ActionTypes.HANDLE_ERROR_MESSAGE_FOR_G_INV,
  errorMessagesInRedux: data,
});
export const dispatchErrorMsgNDCDetail = (data) => ({
  type: ActionTypes.GET_ERROR_MSG_NDC_DETAILS,
  payload: data,
});

// set the setNDCDetailsData data for display screen
export const setNDCDetailsData = (data) => ({
  type: ActionTypes.SET_NDC_DETAILS_REPORT_DATA,
  payload: data,
});

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
    // dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

// To get plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};

//  get rebate programe Dropdown
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data.data;
    })
    .catch((response) => {});
};

//API call to get the NDC details grid data
export const getndcdetailsgrid = (value) => (dispatch) => {
  dispatch(setLoading(true));

  return axios
    .post(`${serviceEndPoint.GET_NDC_DETAILS_GRID}`, value)
    .then((response) => {
      dispatch(setLoading(false));
      if (response?.data?.ndcDetailsGridVO.length > 0) {
        dispatch(setNDCDetailsData(response?.data?.ndcDetailsGridVO));
      } else {
        dispatch(showNoDataMessage());
      }
      return response?.data?.ndcDetailsGridVO;
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setNDCDetailsData([]));
    });
};
export const setNDCDetailReportData = (payload) => ({
  type: ActionTypes.SET_NDC_REPORT_DATA_AVAIL,
  payload,
});
// set the setNDCHistoryData data for display screen
export const setExportAllData = (data, key) => ({
  type: ActionTypes.SET_NDC_DETAIL_REPORT_DATA_ALL,
  payload: data,
  key,
});
//API call to get the NDC details grid data
export const reportData = (value, i) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_NDC_DETAILS_GRID}`, value)
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(setExportAllData(response?.data?.ndcDetailsGridVO, i));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setExportAllData([], 'noData'));
    });
};

export const getndcDetailsGridForExportAll =
  (value, drugSeqNumArr) => (dispatch) => {
    for (let i = 0; i < drugSeqNumArr.length; i++) {
      const values = {
        ...value,
        drugSeqNum: drugSeqNumArr[i],
      };
      dispatch(reportData(values, i));
    }
  };

//API call to get the labeler data
export const getLabelerList = async (values) => {
  try {
    const response = await axios.get(
      serviceEndPoint.GET_ALL_LABELER_LIST,
      values
    );
    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data.data;
      // eslint-disable-next-line no-else-return
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};
